import React from 'react';

import Calendar from '../../../assets/icons/calendar.svg';
import Location from '../../../assets/icons/location.svg';
import Shield from '../../../assets/icons/shield.svg';
import StarEmpty from '../../../assets/icons/star_empty.svg';

import './qualityCareSection.scss';

export default function QualityCareSection() {
  return (
    <section id="quality-care" className="quality_care">
      <h2>
        Quality care, backed
        <br />
        {' '}
        by
        <span className="salmon"> real results</span>
      </h2>

      <div className="stats-container">
        <div className="stat">
          <Shield />
          <h3>170M+</h3>
          <p>lives covered</p>
        </div>
        <div className="stat">
          <Location />
          <h3>30+</h3>
          <p>states covered</p>
        </div>
        <div className="stat">
          <StarEmpty />
          <h3>87.5%</h3>
          <p>
            of patients
            <br className="mobile-only" />
            {' '}
            recommend us
          </p>
        </div>
        <div className="stat">
          <Calendar />
          <h3>60%</h3>
          <p>
            of bookings completed
            <br />
            {' '}
            within 48 hours
          </p>
        </div>
      </div>
    </section>
  );
}
